import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "app__inner-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "app__inner" }
const _hoisted_4 = { class: "app__body" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "app__help-text dt-branding-text-color"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "app__help-text-title" }, "NEED HELP?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade-up" }, {
      default: _withCtx(() => [
        (_ctx.foundBranding)
          ? (_openBlock(), _createElementBlock("div", {
              class: "app__room-background-container",
              key: _ctx.foundBranding.backgroundImage || _ctx.foundBranding.backgroundColor,
              style: _normalizeStyle(_ctx.getBrandingBackgroundColor)
            }, [
              (!_ctx.foundBranding.backgroundColor && _ctx.foundBranding.backgroundImage)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "app__room-background",
                    onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBackgroundLoaded && _ctx.onBackgroundLoaded(...args))),
                    src: _ctx.foundBranding.backgroundImage,
                    alt: "Room Background",
                    ref: "roomBackground",
                    crossorigin: "anonymous"
                  }, null, 40, _hoisted_2))
                : _createCommentVNode("", true)
            ], 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_Transition, {
          mode: "out-in",
          name: "fade"
        }, {
          default: _withCtx(() => [
            (_ctx.foundBranding && _ctx.foundBranding.logo)
              ? (_openBlock(), _createElementBlock("img", {
                  crossorigin: "anonymous",
                  onLoad: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onLogoLoaded && _ctx.onLogoLoaded(...args))),
                  key: _ctx.foundBranding.logo,
                  class: "app__logo",
                  alt: "Ditto",
                  src: _ctx.foundBranding.logo
                }, null, 40, _hoisted_5))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "app__logo",
                  alt: "Ditto",
                  src: require('../public/images/dittoLogoWhite.png')
                }, null, 8, _hoisted_6))
          ]),
          _: 1
        }),
        _createVNode(_component_router_view, {
          class: "app__router-view",
          brandingAccentColor: _ctx.brandingAccentColor,
          onOnRoomCodeInput: _ctx.onRoomCodeInput,
          onRoomFound: _ctx.roomFoundHandler
        }, null, 8, ["brandingAccentColor", "onOnRoomCodeInput", "onRoomFound"])
      ]),
      (_ctx.foundBranding && _ctx.foundBranding.helpText)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.foundBranding.helpText), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}